// extracted by css-extract-rspack-plugin
export default {"container":"_293ebb35","endOfYearContainer":"_99d4d1dc _293ebb35","onlyShippingPromosContainer":"_52652e6f"};